import RequestAbstract from "../abstract";

export default class FiltersBins extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/filters-bins";
    }

}
